import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-statistic-card',
  templateUrl: './statistic-card.component.html',
  styleUrls: ['./statistic-card.component.scss']
})
export class StatisticCardComponent implements OnInit {

  @Input() totalNumber: number;
  @Input() type: 'total' | 'ongoing' | 'delivered';
  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/statistic-card/statistic-card.component.ts